import { Injectable, signal, Signal } from '@angular/core';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';
export type DeviceOS = 'ios' | 'macos' | 'android' | 'windows' | 'linux' | 'unknown';

@Injectable({
  providedIn: 'root',
})
export class DeviceDetectorService {
  private _deviceType = signal<DeviceType>(this.detectDeviceType());
  deviceType: Signal<DeviceType> = this._deviceType.asReadonly();

  private _deviceOS = signal<DeviceOS>(this.detectOS());
  deviceOS: Signal<DeviceOS> = this._deviceOS.asReadonly();

  private detectDeviceType(): DeviceType {
    const ua = navigator.userAgent;

    if (/Mobi|Android|iPhone|IEMobile|Opera Mini/i.test(ua)) {
      return 'mobile';
    } else if (/iPad|Tablet|PlayBook/i.test(ua)) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  }

  private detectOS(): DeviceOS {
    const ua = navigator.userAgent;
    const p = ('userAgentData' in navigator
      ? (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform
      : undefined);

    // iPadOS часто маскируется под macOS, поэтому дополнительно проверяем touch
    if (/iPad|iPhone|iPod/.test(ua) || (p === 'macOS' && navigator.maxTouchPoints > 1)) return 'ios';
    if (p === 'macOS' || /Mac OS X/.test(ua)) return 'macos';
    if (p === 'Windows' || /Windows/.test(ua)) return 'windows';
    if (p === 'Android' || /Android/.test(ua)) return 'android';
    if (p === 'Linux' || /Linux/.test(ua)) return 'linux';
    return 'unknown';
  }

  isMobile(): boolean {
    return this._deviceType() === 'mobile';
  }

  isTablet(): boolean {
    return this._deviceType() === 'tablet';
  }

  isDesktop(): boolean {
    return this._deviceType() === 'desktop';
  }

  isIOS(): boolean {
    return this._deviceOS() === 'ios';
  }

  getDeviceType(): DeviceType {
    return this._deviceType();
  }

  getDeviceOS(): DeviceOS {
    return this._deviceOS();
  }
}
